import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import SortByOptions from 'src/modules/search/posts/components/sortByOptions';
import CommunityMembersSearchSidebar from 'src/modules/community/communitySearch/components/communityMembersSearchSidebar';

type Props = {
  searchType: string;
  query: string;
}
export default function CommunitySearchSidebar({ searchType, query }: Props) {
  const { searchResults } = useSelector(({ pages }) => pages.search);

  if (searchType === 'members') {
    return <CommunityMembersSearchSidebar />;
  } else if (!!query && searchResults.length > 0) {
    return (
      <div className="search__sidebar filter-options">
        <div className="filter-header">
          <div className="filter-title">{i18n.t('Sort results')}</div>
        </div>
        <SortByOptions />
      </div>
    );
  }
  return null;
}
